import {FC} from 'react'

import {Text, TextVariant} from '@/components/common/content/Text'
import {getTrademarkDisputesContent} from '@/content/trademarkDisputes'
import {Link, useTranslation} from '@/i18n'
import {theme} from '@/theme/theme'
import {Locale} from '@/utils/constants'
import {formatDate} from '@/utils/formatDate'

import {IpCaseDetailRow} from '../case/IpCaseDetailRow'

type RelatedIpCaseBySubcategoryProps = {
  name: string
  linkHref: string
  caseNumber: string
  dateOfDecision: string
  jurisdiction: string
  subjectMatter: string
  isHidden?: boolean
}

export const RelatedIpCaseBySubcategory: FC<RelatedIpCaseBySubcategoryProps> = ({
  name,
  linkHref,
  caseNumber,
  dateOfDecision,
  jurisdiction,
  subjectMatter,
  isHidden,
}) => {
  const {t} = useTranslation()
  const {caseNumberTitle, decisionDateTitle, jurisdictionTitle, subjectMatterTitle} =
    getTrademarkDisputesContent()

  return (
    <>
      <div className="case" hidden={isHidden}>
        <div className="title">
          <Text variant={TextVariant.h4} element="h3" className="underline">
            <Link href={linkHref} prefetch={false}>
              {name}
            </Link>
          </Text>
        </div>
        <IpCaseDetailRow title={t(caseNumberTitle)} description={caseNumber} />
        <IpCaseDetailRow
          title={t(decisionDateTitle)}
          description={formatDate(dateOfDecision, Locale.en, false, 'dd MMM, yyyy')}
        />
        <IpCaseDetailRow title={t(jurisdictionTitle)} description={jurisdiction} />
        <IpCaseDetailRow title={t(subjectMatterTitle)} description={subjectMatter} />
      </div>

      <style jsx>{`
        .case:not([hidden]) ~ .case:not([hidden]) {
          margin-top: ${theme.spacing[5]};
          padding-top: ${theme.spacing[5]};
          border-top: 1px solid ${theme.palette.gray[200]};
        }
        .title {
          display: inline-block;
          margin-bottom: ${theme.spacing[3]};
        }
      `}</style>
    </>
  )
}
